import { render, staticRenderFns } from "./VesselTrialTestDetails.vue?vue&type=template&id=67baedbe&scoped=true&"
import script from "./VesselTrialTestDetails.vue?vue&type=script&lang=js&"
export * from "./VesselTrialTestDetails.vue?vue&type=script&lang=js&"
import style0 from "./VesselTrialTestDetails.vue?vue&type=style&index=0&id=67baedbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67baedbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDivider,VSpacer,VTextarea})
